import type { UserFriendlyError } from "./types";
import { ERROR_PATTERNS } from "./constants";
import { handleHttpStatusError } from "./helpers/httpStatusHelpers";

/**
 * Transforme une erreur technique en message compréhensible
 */
export function humanizeError(errorMessage: string | null | undefined, httpStatus?: number): UserFriendlyError {
	// Si on a un code HTTP, on peut donner un message générique approprié
	if (httpStatus) {
		const httpStatusResult = handleHttpStatusError(errorMessage, httpStatus, ERROR_PATTERNS);
		if (httpStatusResult) {
			return httpStatusResult;
		}
	}

	// Sinon, on cherche un pattern qui correspond au message
	if (errorMessage) {
		for (const { pattern, message } of ERROR_PATTERNS) {
			const match = errorMessage.match(pattern);
			if (match) {
				// Si message est une fonction, l'appeler avec le match
				if (typeof message === "function") {
					return message(match);
				}
				return message;
			}
		}
	}

	// Fallback when no status and no pattern matched: do not assert a false cause (e.g. "connexion").
	// Callers should log the raw error for diagnosis; we only show a neutral, actionable message.
	return {
		title: "Une erreur est survenue",
		message:
			"La cause exacte n'a pas pu être identifiée. Réessayez ou contactez le support en indiquant l'action effectuée.",
		canRetry: true,
	};
}
